import React, { useEffect } from 'react'
import { Button, Card, Col, Drawer, Form, Icon, notification, Row, Table, Select, Upload, Tabs } from 'antd'
import _ from 'lodash'
import { FormUtils as GetAllFormFields, TableComp } from 'sz-react-utils'
import Request, { API_URL, LAPI_URL } from '../../request'
import { connect } from 'react-redux'
import moment from 'moment'
const Option = Select.Option

@Form.create()
class SalarySlipAction extends React.Component {
    state = {
        visible: true,
        loading: false,
        leaveApproved: false,
        leaveTypes: ['CL(Casual Leave)', 'LWP(Leave Without Pay)', 'HD(Half Day)'],
        sandwichLeaveDetails: [],
        casualLeaveDetails: []
    }

    componentDidMount() {

    }

    setFormDetails() {
        let { record, form } = this.props;
        setTimeout(() => {
            form.setFieldsValue({
                startDate: moment(record.startDate),
                endDate: moment(record.endDate),
                leaveDuration: record.leaveDuration,
                leaveType: record.leaveType
            })
        }, 150)
    }

    async getLeaveDetails() {
        let sandwichLeaveDetails = await this.getSandwichLeaveDetails();
        let casualLeaveDetails = await this.getCasualLeaveDetails();
        this.setState({ sandwichLeaveDetails, casualLeaveDetails })
        if (casualLeaveDetails.total >= 1 && sandwichLeaveDetails.total < 2) {
            this.setState({ leaveTypes: ['LWP(Leave Without Pay)', 'HD(Half Day)', 'Sandwich Leave'] })
        } else if (casualLeaveDetails.total >= 1 && sandwichLeaveDetails.total >= 2) {
            this.setState({ leaveTypes: ['LWP(Leave Without Pay)', 'HD(Half Day)'] })
        } else if (sandwichLeaveDetails.total >= 2) {
            this.setState({ leaveTypes: ['CL(Casual Leave)', 'LWP(Leave Without Pay)', 'HD(Half Day)'] })
        } else {
            this.setState({ leaveTypes: ['CL(Casual Leave)', 'LWP(Leave Without Pay)', 'HD(Half Day)', 'Sandwich Leave'] })
        }
    }

    async getSandwichLeaveDetails() {
        let { record } = this.props
        let data = {
            userId: record.userId,
            leaveType: 'Sandwich Leave',
            leaveYear: moment().format('YYYY'),
            status: "Approved"
        }
        let response = await Request.getUserLeaves(data);
        return response
    }
    async getCasualLeaveDetails() {
        let { record } = this.props
        let data = {
            userId: record.userId,
            leaveType: 'CL(Casual Leave)',
            leaveYearMonth: moment().format('YYYY-MM'),
            status: 'Approved'
        }
        let response = await Request.getUserLeaves(data);
        return response
    }

    onClose = () => {
        setTimeout(() => {
            this.props.onClose()
        }, 400)
    }

    handleDisApprove = (record) => {

    }

    handleSubmit = e => {
        e.preventDefault();
        const { form, record } = this.props;
        form.validateFieldsAndScroll(async (err, valData) => {
            if (!err) {
                let values = _.clone(valData);
                values._id = record._id
                let response = await Request.updateSalarySlipRequest(values)
                if (!response.error) {
                    this.onClose()
                    notification.success({
                        message: 'Success',
                        description: response.message
                    })
                } else {
                    notification.error({
                        message: 'Error Saving',
                        description: response.message
                    })
                }
            }

        })
    }

    render() {

        const { visible } = this.state
        const inputTypes = {
            fields: [
                {
                    label: 'Action',
                    key: 'status',
                    required: true,
                    type: 'select',
                    options: ['Approved', 'Disapproved'],
                    onChange: v => {
                        this.props.form.setFieldsValue({
                            status: v
                        })
                    }
                }
            ]
        }

        const {
            form: { getFieldDecorator, }
        } = this.props

        return (
            <Drawer
                title={
                    <div>
                        <React.Fragment>
                            Approve/Disapprove
                        </React.Fragment>
                    </div>
                }
                placement="right"
                closable={true}
                onClose={this.onClose}
                width={400}
                visible={visible}>
                <Card>
                    <Form onSubmit={this.handleSubmit} style={{ marginTop: 8 }}>
                        <div>
                            <GetAllFormFields
                                apiurl={LAPI_URL}
                                inputSchema={inputTypes}
                                getFieldDecorator={getFieldDecorator}
                            />
                        </div>
                        <Row style={{ marginTop: '20px' }}>
                            <Col span={8} />
                            <Col span={8}>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    style={{ marginBottom: 10 }}
                                    loading={this.props.loading}>
                                    SAVE
                                </Button>
                            </Col>
                            <Col span={8} />
                        </Row>
                    </Form>
                </Card>
            </Drawer>
        )
    }
}

const mapStateToProps = ({ global, router }) => ({
    loading: global.buttonLoading,
    search: router.location.search
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SalarySlipAction)
